import { Decoder, number, object, string } from '@mojotech/json-type-validation'

import { TestCase } from '@/domain/value_objects/testCase/TestCase'

export const testCaseDecoder: Decoder<TestCase> = object({
  in: string(),
  out: string(),
  problemId: string(),
  serial: number()
})
